/**
 * 通用按钮组件
 * 支持多种变体（主要、次要、危险等）和尺寸
 */
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
}

const variants: Record<string, string> = {
  primary: 'bg-accent-500 hover:bg-accent-400 text-surface-950 border-transparent',
  secondary: 'bg-surface-700 hover:bg-surface-600 text-surface-200 border-surface-600',
  danger: 'bg-red-600 hover:bg-red-500 text-white border-transparent',
  ghost: 'hover:bg-surface-700 text-surface-400 hover:text-surface-200 border-transparent',
};

const sizes: Record<string, string> = {
  sm: 'px-2.5 py-1 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
};

/** 通用按钮组件：支持 primary/secondary/danger/ghost 变体与三种尺寸 */
export function Button({
  variant = 'primary',
  size = 'md',
  icon,
  children,
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      className={`inline-flex min-h-9 items-center justify-center gap-2 rounded font-semibold transition-colors
        disabled:opacity-50 disabled:cursor-not-allowed border
        ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </button>
  );
}
